<template>
    <NuxtLayout name="default" mainClass="inside_main">
      <div class="contact-form">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="section_title">
                <h1>تواصل معنا</h1>
              </div>
            </div>
          </div>
          <div class="contact-form-inputs">
            <form id="contactForm" @submit.prevent="handleSubmit">
              <div class="row">
                <!-- Name Input -->
                <div class="col-md-6">
                  <div class="input-group">
                    <input
                      name="first_name"
                      v-model="name"
                      id="first_name"
                      type="text"
                      placeholder="الاسم"
                      class="form-control"
                    />
                    <span class="has-error text-danger w-100">{{ errors.name }}</span>
                  </div>
                </div>
                <!-- Phone Input -->
                <div class="col-md-6">
                  <div class="input-group">
                    <input
                      name="mobile"
                      id="mobile"
                      v-model="phoneNumber"
                      type="tel"
                      placeholder="512345678"
                      class="form-control mobile"
                      inputmode="numeric"
                      maxlength="10"
                    />
                    <span class="has-error text-danger w-100">{{ errors.phoneNumber }}</span>
                    <div class="country_code">
                      <img src="/website/assets/img/SaudiArabiaFlag.png" alt="SaudiArabiaFlag" />
                      <span>+966</span>
                    </div>
                  </div>
                </div>
                <!-- Email Input -->
                <div class="col-md-6">
                  <div class="input-group">
                    <input
                      name="email"
                      id="email"
                      v-model="email"
                      type="email"
                      placeholder="البريد الإلكتروني"
                      class="form-control"
                    />
                    <span class="has-error text-danger w-100">{{ errors.email }}</span>
                  </div>
                </div>
                <!-- Section Select -->
                <div class="col-md-6">
                  <div class="input-group">
                    <select name="sectionId" v-model="sectionId" class="form-control">
                      <option value="" disabled>اختر القسم</option>
                      <option v-for="section in sections" :key="section.id" :value="section.id">
                        {{ section.name }}
                      </option>
                    </select>
                    <span class="has-error text-danger w-100">{{ errors.sectionId }}</span>
                  </div>
                </div>
                <!-- Message Textarea -->
                <div class="col-md-12">
                  <div class="input-group">
                    <textarea
                      name="details"
                      id="details"
                      v-model="message"
                      placeholder="نص الرسالة"
                      class="form-control"
                      rows="6"
                    ></textarea>
                    <span class="has-error text-danger w-100">{{ errors.message }}</span>
                  </div>
                </div>
                <!-- Submit Button -->
                <div class="col-md-12">
                  <div class="input-group mb-0">
                    <button id="contactFormBTN" type="submit" class="form-control has-spinner-link">
                      <div class="button_text">ارسال</div>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </NuxtLayout>
  </template>
  
  <script setup lang="ts">
  import { ref, reactive, onMounted,computed } from 'vue'
  import { useHead } from '#imports'
  import Swal from 'sweetalert2'
  import { useWebsiteStore } from '~/store/website'
  import { formsRepository } from '~/utils/formsRepository'
  import { websiteRepository } from '~/utils/websiteRepository'
  import { useGlobalAlert } from '~/composables/useGlobalAlert'
  import { useAuthStore } from "@/store/auth"
      // Authentication state

  const websiteStore = useWebsiteStore()
  const { showAlert } = useGlobalAlert()
  
  // Sections data for the select input
  const sections = ref([])
  
  async function fetchSectionData() {
    const { $api } = useNuxtApp()
    const repo = websiteRepository($api)
    try {
      const response = await repo.getSections()
      sections.value = response.data || []
    } catch (error) {
      console.error('Error fetching sections:', error)
    }
  }
  
  // Initialize form fields and error messages
  const errors = reactive({
    name: '',
    phoneNumber: '',
    email: '',
    sectionId: '',
    message: ''
  })
  
  const name = ref('')
  const phoneNumber = ref('')
  const email = ref('')
  const message = ref('')
  const sectionId = ref('')
  


  // Validate form fields before submission
  function validateForm() {
    let isValid = true
  
    // Reset errors
    errors.name = ''
    errors.phoneNumber = ''
    errors.email = ''
    errors.sectionId = ''
    errors.message = ''
    const regex = /^[5]\d{8,9}$/;
  
    if (!name.value.trim()) {
      errors.name = 'الاسم مطلوب'
      isValid = false
    }
    if (!phoneNumber.value.trim()) {
      errors.phoneNumber = 'رقم الهاتف مطلوب'
      isValid = false
    }else if(!regex.test(phoneNumber.value)){
        errors.phoneNumber =  "يرجى إدخال رقم جوال صحيح يبدأ بـ 5 ويكون طوله 9 أو 10 أرقام.";
        isValid = false
    }
    if (email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      errors.email = 'صيغة البريد الإلكتروني غير صحيحة'
      isValid = false
    }
    if (!sectionId.value) {
      errors.sectionId = 'القسم مطلوب'
      isValid = false
    }
    if (!message.value.trim()) {
      errors.message = 'نص الرسالة مطلوب'
      isValid = false
    }
  
    return isValid
  }
  


  const authStore = useAuthStore()
  const isAuthenticated = computed(() => authStore.isAuthenticated)
  const user = computed(() => authStore.user)

  // Auto-fill fields if user is authenticated
  onMounted(() => {
    fetchSectionData()
    if (isAuthenticated.value) {
        
      name.value = user.value?.name || ''
      phoneNumber.value = user.value?.phone_number || ''
    }
  })

  // Handle form submission with validations
  const formRepo = formsRepository()
  
  const handleSubmit = async () => {
    if (!validateForm()) {
      return
    }
  
    const formData = new FormData()
    formData.append('name', name.value)
    formData.append('phone_number', phoneNumber.value)
    formData.append('email', email.value)
    formData.append('section_id', sectionId.value)
    formData.append('message', message.value)
  
    try {
      const response = await formRepo.contacts(formData)
      if (response.response.status === true) {
        showAlert('تم الارسال بنجاح', 'success')
        // Reset the form fields
        sectionId.value = ''
        name.value = ''
        phoneNumber.value = ''
        email.value = ''
        message.value = ''
      } else {
        Swal.fire({
          icon: 'error',
          title: response.response?.message ?? 'حدث خطأ ما، يرجى المحاولة مرة أخرى',
          showConfirmButton: false,
          timer: 2000
        })
      }
    } catch (error: any) {
      console.error('Failed to store contact form', error)
      if (error.data && error.data.errors) {
        const apiErrors = error.data.errors
        errors.message = apiErrors.message ? apiErrors.message.join(', ') : ''
        errors.sectionId = apiErrors.section_id ? apiErrors.section_id.join(', ') : ''
        errors.name = apiErrors.name ? apiErrors.name.join(', ') : ''
        errors.email = apiErrors.email ? apiErrors.email.join(', ') : ''
        errors.phoneNumber = apiErrors.phone_number ? apiErrors.phone_number.join(', ') : ''
      }
    }
  }
  
  // Fetch sections data when component is mounted
  onMounted(() => {
    fetchSectionData()
  })
  
  useHead({
    title: 'تواصل معنا',
    meta: [
      { property: 'og:title', content: `الأقسام | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
      { property: 'twitter:title', content: `الأقسام | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
    ]
  })
  </script>
  